import 'react-dropdown/style.css'
import './css/ReeferView.css'
import './css/common.css'

import React, { useEffect, useRef, useState } from "react";
import useWebSocket from "react-use-websocket";
import toast, { Toaster } from 'react-hot-toast';
import { getReefers } from "./utils/utils";
import ReeferAccordionTable from "./ReeferAccordionTable";
import Header from "./utils/Header";
import Dropdown from "react-dropdown";

const ReeferView = () => {
    const [reefers, setReefers] = useState({});
    const [reeferOptions, setReeferOptions] = useState({});
    const [selectedReefer, setSelectedReefer] = useState({});
    const [accordionTable, setAccordionTable] = useState(null)
    const lastMessageTimestamp = useRef(Date.now());

    const socketUrl = process.env.REACT_APP_REEFER_WEBSOCKET;
    const {
        sendMessage,
        sendJsonMessage,
        lastMessage,
        lastJsonMessage,
        readyState,
        getWebSocket,
    } = useWebSocket(socketUrl, {
        heartbeat: {
            message: 'ping',
            returnMessage: 'pong',
            timeout: 60000, // 1 minute, if no response is received, the connection will be closed
            interval: 25000, // every 25 seconds, a ping message will be sent
        },
        // Will attempt to reconnect on all close events, such as server shutting down
        shouldReconnect: (closeEvent) => true,
    });

    useEffect(() => {
        localStorage.removeItem("reefers");
        getReefers().then(response => {
            setReeferOptions(response);
            const storageReefer = localStorage.getItem("reefer");
            if (storageReefer) {
                handleSelectReefer(storageReefer);
            }
        });
        checkWSConnection(15000);
    }, []);

    useEffect(() => {
        if (Object.keys(reeferOptions).length === 1) {
            handleSelectReefer(Object.keys(reeferOptions)[0])
        }
    }, [reeferOptions]);

    useEffect(() => {
        if (Object.keys(reefers).length > 0) {
            setAccordionTable(
                <ReeferAccordionTable reefers={reefers} handleModeChange={handleModeChange}>
                </ReeferAccordionTable>
            );
        }
        else {
            setAccordionTable(null);
        }
    }, [reefers]);

    useEffect(() => {
        if (lastJsonMessage) {
            if (lastJsonMessage.payload && lastJsonMessage.payload.message_type === "chamber_statuses") {
                const raw_payload = lastJsonMessage.payload.chamber_statuses;
                let chamberStatuses = {}
		let lowestName = raw_payload[0].name;
		let validPayloadLength = 13;
		if (lowestName === 1) {
		    validPayloadLength = 14
		}
                for (let i = 0; i < validPayloadLength; i++) {
                    chamberStatuses[raw_payload[i].name] = {
                        "burn_rate": raw_payload[i].burn_rate,
                        "mode": raw_payload[i].service_program,
                        "pressure": raw_payload[i].pressure,
                        "leak_rate": raw_payload[i].leak_rate,
                        "active": raw_payload[i].active
                    }
                }
                let temp_reefers = {...reefers};
                if (temp_reefers[lastJsonMessage.reefer]) {
	            if (temp_reefers[lastJsonMessage.reefer]["chamber_statuses"]) {
                        temp_reefers[lastJsonMessage.reefer]["chamber_statuses"] = Object.assign(
                            temp_reefers[lastJsonMessage.reefer]["chamber_statuses"],
                            chamberStatuses
                        )
		    }
		    else {
		        temp_reefers[lastJsonMessage.reefer]["chamber_statuses"] = chamberStatuses
		    }
                }
                setReefers(temp_reefers)
            }
            if (lastJsonMessage.payload && lastJsonMessage.payload.message_type === "sensor_data") {
                const raw_payload = lastJsonMessage.payload.sensor_data;
                let rounded_temp = raw_payload.temperature;
                if (rounded_temp) {
                    rounded_temp = Math.round(raw_payload.temperature * 10) / 10;
                }
                let sensor_data = {
                    "temperature": rounded_temp,
                    "humidity": raw_payload.humidity,
                    "instantaneous_pressure": raw_payload.pressure
                }
                let temp_reefers = {...reefers};
                if (temp_reefers[lastJsonMessage.reefer]) {
                    temp_reefers[lastJsonMessage.reefer]["sensor_data"] = sensor_data
                }
                setReefers(temp_reefers)
            }
            if (lastJsonMessage.payload
                && lastJsonMessage.payload.message_type === "status_message"
                && lastJsonMessage.payload.status_text) {
                const statusText = lastJsonMessage.payload.status_text;

                const rateDataRegEx = /rate: (\d)*.(\d)*/g;
                const rateDataArray = statusText.match(rateDataRegEx);
                let rate = null;
                if (rateDataArray) {
                    rate = rateDataArray[0].split(" ")[1];
                    rate = rate.replace("(", "").replace(")", "");  // Just in case the parentheses are still there
                }
                let rateData = {
                    "rate_data": rate
                }
                let temp_reefers = {...reefers};
                if (temp_reefers[lastJsonMessage.reefer]) {
                    temp_reefers[lastJsonMessage.reefer]["rate_data"] = rateData;
                }
                setReefers(temp_reefers);
            }
            if (lastJsonMessage.type === "error" && lastJsonMessage.payload) {
                // let message = lastJsonMessage.payload.split(" ");
                // let erroredReefer = message[message.length - 1];
                let temp_reefers = {...reefers};
                // if (temp_reefers[erroredReefer]) {
                //     temp_reefers[erroredReefer]["error"] = true;
                // }
                setReefers(temp_reefers);
            }
            lastMessageTimestamp.current = Date.now();
        }
    }, [lastJsonMessage])

    const handleSelectReefer = async (selection) => {
        if (reeferOptions && reeferOptions[selection]) {
            let url = process.env.REACT_APP_FLEET_MANAGER_URL
                    + process.env.REACT_APP_FLEET_MANAGER_ENDPOINT_COMPANY_REEFER
                    + reeferOptions[selection].id
            await fetch(url, {method: 'GET'})
                .then(response => {
                    return response.json();
                })
                .then(async response => {
                    let reeferJson = {}
                    localStorage.setItem("reefer", selection);
                    setSelectedReefer(selection);

                    if (response.length === 0) {
                        toast.error("Error unable to retrieve reefer");
                    } else {
                        reeferJson[response.serial_number] = {
                            "id": response.id,
                            "name": response.name,
                        }
                    }
                    await handleReeferSubscription(reeferJson);
                 });
        }
    }

    const formatReeferNameMessages = (reefersObject) => {
        // Format the names of the reefers for multiplex consumption (generally use for subscribe/unsubscribe messages)
        let reeferNameMsg = [];
        for (const reefer in reefersObject) {
            reeferNameMsg.push({"name": reefer, "fake": false})
        }
        return reeferNameMsg;
    }

    const handleReeferSubscription = async (newReefers) => {
        if (Object.keys(reefers).length > 0) {
            let reeferMsg = formatReeferNameMessages(reefers);
            sendMessage(JSON.stringify({"action": "unsubscribe", "reefers": reeferMsg}))
        }
        if (Object.keys(newReefers).length > 0) {
            let reeferMsg = formatReeferNameMessages(newReefers);
            sendMessage(JSON.stringify({"action": "subscribe", "reefers": reeferMsg}))
        }
        localStorage.setItem('reefers', JSON.stringify(newReefers));
        await setReefers(newReefers);
    }

    const handleModeChange = (reeferSerialNo, chamberName, mode, notify= true) => {
        let jsonMsg = {
            "action": "change_mode",
            "reefer": reeferSerialNo,
            "chamber": parseInt(chamberName),
            "mode": mode};
        sendMessage(JSON.stringify(jsonMsg));
        if (notify) {
            let toastMsg = "Changing mode on "
                + reeferSerialNo
                + " chamber "
                + chamberName
                + " to "
                + mode
                + ". Please be patient."
            toast.success(toastMsg);
        }
    }

    const checkWSConnection = async (timeout) => {
        const storedReefers = JSON.parse(localStorage.getItem("reefers"));
        if (((Date.now() - lastMessageTimestamp.current) > timeout) && storedReefers) {
            await handleReeferSubscription(storedReefers);
        }
        setTimeout(checkWSConnection.bind(null, timeout), timeout);
    }


    return (
        <div>
            <Header />
            <div className="leak-rate-container">
                <div className="selection-container">
                    <Dropdown
                            options={Object.keys(reeferOptions)}
                            onChange={(option) => {
                                handleSelectReefer(option.value);
                            }}
                            value={selectedReefer}
                            placeholder="Reefer"
                    />
                </div>
                <div className="accordion-table-container">
                    {accordionTable}
                </div>
                <Toaster />
            </div>
        </div>
    )

}

export default ReeferView;
